import {ChangeDetectionStrategy, Component, input} from '@angular/core'
import {IconProp} from '@fortawesome/fontawesome-svg-core'

@Component({
  selector: 'bgo-shortcuts',
  templateUrl: './shortcuts.component.html',
  styleUrls: ['./navbar-shortcuts-common.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShortcutsComponent {
  title = input.required<string>()
  link = input.required<string>()
  icon = input<IconProp>()
}
